/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistatusProfile.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edistatus-profile";

export class AutogenModelEdistatusProfile<RowType extends ModelRow> extends Endpoint<RowType, RowEdistatusProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistatusProfile extends ModelRow<RowEdistatusProfileFields> {
	constructor(values?: Partial<RowEdistatusProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistatusProfileFields {
	ack_xmit_method: string;
	agent_payee_id: string;
	allow_update: string;
	alt_partner_id: string;
	audit_cutoff_days: number;
	audit_interval: number;
	batch_method: string;
	carrier_id: string;
	company_id: string;
	consolidates_stops: string;
	create_method: string;
	create_svrfail: string;
	days_to_retain: number;
	delay_req: string;
	dest_stop_no: string;
	direction: string;
	edi_comm_id: number;
	enf_batch_cont: string;
	enf_batch_cont_997: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	hold_for_preverr: string;
	hold_type: string;
	id: string;
	ignore_map_errors: string;
	img_def_loc_dir: string;
	img_dir_local: string;
	img_document_types: string;
	img_filetype: string;
	img_required: string;
	individual_batch: string;
	intercompany: string;
	next_batch: number;
	notes: string;
	orig_stop_no: string;
	partner_id: string;
	partner_name: string;
	process_priority: number;
	remove_file: string;
	remove_func_ack: string;
	send_func_ack: string;
	send_to_company: string;
	skip_manual_orders: string;
	special_processing: string;
	st02_format: string;
	status_on_delivery: string;
	status_on_pickup: string;
	template_id: number;
	transaction_set: string;
	transmit_method: string;
	update_stop: string;
	use_master_batch: string;
	use_show_as: string;
	version: string;
	batch: string;
}

